import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';
import { Box, Divider, Stack, Typography } from '@mui/material';
import type { PublicCatalogSupport } from '@/features/operations/api';

/**
 * Why buying here is not buying from a stranger (CAT-3): PhoneTec checked the device and sells it
 * itself, and the warranty in force backs it. The wording is pending validation with PhoneTec
 * (X-2). Without a configured warranty the block keeps the backing and leaves the warranty out,
 * rather than print an empty duration (BR-024).
 */
export function DeviceTrustBlock({ warranty }: { warranty: PublicCatalogSupport['warranty'] }) {
  return (
    <Box
      component="section"
      aria-labelledby="device-trust-title"
      sx={{ border: 1, borderColor: 'divider', borderRadius: '16px', p: 2.5 }}
    >
      <Stack spacing={2}>
        <Stack direction="row" spacing={1.5} alignItems="flex-start">
          <VerifiedOutlinedIcon color="primary" aria-hidden />
          <Stack spacing={0.5}>
            <Typography id="device-trust-title" variant="h6" component="h2">
              Verificado y publicado por PhoneTec
            </Typography>
            <Typography variant="body2" color="text.secondary">
              PhoneTec revisó este equipo en persona, lo certificó y lo vende directamente. No es la
              publicación de un particular: si algo no está bien, respondemos nosotros.
            </Typography>
          </Stack>
        </Stack>
        {warranty ? (
          <>
            <Divider />
            <Stack spacing={0.5}>
              <Typography variant="subtitle1" component="h3" sx={{ fontWeight: 700 }}>
                Garantía de {warranty.durationMonths}{' '}
                {warranty.durationMonths === 1 ? 'mes' : 'meses'}
              </Typography>
              {/* The conditions are written in the panel; their line breaks are kept. */}
              <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'pre-line' }}>
                {warranty.conditions}
              </Typography>
            </Stack>
          </>
        ) : null}
      </Stack>
    </Box>
  );
}
